import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { parse, format } from 'date-fns';

@Injectable()
export class PGHDateAdapter extends NativeDateAdapter {
  parse(value: any): Date | null {
    if (value != null && value.length < 9) return null;
    const dateValue = parse(value, 'MM/dd/yyyy', new Date());
    console.log(dateValue);
    if (dateValue != null) return dateValue;
    return null;
  }

  format(date: Date): string {
    return format(date, 'MM/dd/yyyy');
  }
}
